import React, {useEffect, useState} from 'react'
import {Container, Card, Button, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
const ProductsContainer = ({productsData, title, search}) => {
  const [products, setProducts] = useState([])
  const [more, setMore] = useState(15)
  useEffect(() => {
    setProducts(productsData)
  },[more,search])
  
  return <Container >
  {/* <h2 className="mb-5">{title}</h2> */}
  <Row className="justify-content-center">
  {
    products.map((product, index) => {
      if(index < more){
        return <Col  className=" border-0 text-left g-4 my-3" lg={12}> <Link key={product["id"]} to={`/product/${product["id"]}`} className="text-decoration-none text-secondary"> <Card className=" d-flex flex-row">
        <Card.Img className="w-25 h-25" variant="top" src={product.image} />
        <Card.Body >
          <Card.Title className="fs-6">{product.title}</Card.Title>
          <h5 className="text-bold text-left fs-4 my-4">${product.price}</h5>
          <h6 className="fs-6">{product.shippingCost} Shipping From {product.itemLocation}</h6>
  </Card.Body>
</Card>
</Link>
</Col>
      }
      })
  }
    
    </Row>
  </Container>
}

export default ProductsContainer